import Backbone from 'backbone';
import each from 'lodash/each';
import extend from 'lodash/extend';

import { uploadAndProcessFile } from 'zoomforth_zfutils/asset_precursor_file_uploader.js';
import selectFilesWithOs from 'zoomforth_zfutils/select_files_with_os.js';
import MediaLibraryAsset from 'zoomforth_media_library/models/media_library_asset.js';
import { get as intercomTracker } from 'zoomforth_zf/appglobals/intercom-tracker.js';


export class LegacyUploaderInterface {
  constructor () {
    extend(this, Backbone.Events);
  }
  
  triggerUploadWindow({ accept, multiple, forceAssetType } = {}) {
    selectFilesWithOs({ accept, multiple }).done((files)=> {
      each(files, (file) => {
        uploadFileWithLegacyUploaderInterface(file, this, null, forceAssetType);
      });
    });
  }
  
}

const AssetPrecursorModel = Backbone.Model.extend({
  urlRoot: '/asset_precursors'
});


export const uploadFileWithLegacyUploaderInterface = (file, legacyInterface, uploadContext, forceAssetType = null)=> {
  
  // this object lasts over the "lifespan" of the upload.
  // it gets used in other contexts too, and has other objects added to it.
  const uploadData = {
    precursor: new AssetPrecursorModel()
  };
  
  uploadAndProcessFile(
    file,
    {
      onPrecursorCreation: (precursorData)=> {
        uploadData.precursor.set(precursorData);
        legacyInterface.trigger('submit', uploadData);
      },
      onUploadProgress: (precursorData, e, percent)=> {
        uploadData.percent = percent;
        legacyInterface.trigger('progress', uploadData);
      },
      onUploadFailure: (precursorData)=> {
        uploadData.precursor.set(precursorData);
        legacyInterface.trigger('failed-upload', uploadData);
      },
      onBeginProcessing: (precursorData)=> {
        uploadData.precursor.set(precursorData);
        uploadData.precursor.trigger('begin-post-upload-processing');
      },
      onProcessingError: (precursorData)=> {
        uploadData.precursor.set(precursorData);
        legacyInterface.trigger('failed-upload', uploadData);
      },
      onProcessingSuccess: (precursorData)=> {
        uploadData.precursor.set(precursorData);
        const assetModel = new MediaLibraryAsset({id: `${precursorData.assetType}-${precursorData.assetId}`});
        assetModel.fetch().done(()=>{
          legacyInterface.trigger('uploaded', uploadData, assetModel);

          intercomTracker().trackUploadedAssetToMediaLibrary(
            precursorData.assetId,
            precursorData.assetType
          );

        });
      }
    },
    {
      just_uploaded_from: uploadContext || 'media_library',
      force_asset_type: forceAssetType
    }
  );
};
